/**
 * Identidad del sitio en un único lugar.
 *
 * El dominio estaba escrito a mano en doce ficheros —enlaces canónicos, JSON-LD,
 * páginas legales, correos de contacto— así que cambiarlo era una cacería con
 * garantías de dejarse alguno. Aquí solo hay que tocar SITE_DOMAIN.
 *
 * Los ficheros estáticos (index.html, sitemap.xml, robots.txt, llms.txt) no pueden
 * importar esta constante. Para que no se queden atrás, `npm test` ejecuta
 * scripts/check-site-identity.mjs, que compara lo que hay en ellos con este valor
 * y falla nombrando fichero y línea.
 */
export const SITE_DOMAIN = 'www.vapsilver.es';
export const SITE_URL = `https://${SITE_DOMAIN}`;
export const BRAND_NAME = 'VapSilver';

/** El correo va sin «www», aunque el sitio se sirva con él. */
export const MAIL_DOMAIN = SITE_DOMAIN.replace(/^www\./, '');

/** wa.me exige el número sin «+», espacios ni guiones. */
export const WHATSAPP_NUMBER = '34675802783';
export const WHATSAPP_DISPLAY = '+34 675 80 27 83';
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}`;

export const CONTACT_EMAIL = `contacto@${MAIL_DOMAIN}`;
export const RETURNS_EMAIL = `devoluciones@${MAIL_DOMAIN}`;
export const PRIVACY_EMAIL = `privacidad@${MAIL_DOMAIN}`;
